module.exports = __webpack_public_path__ + "static/media/slack.13ddc250.png";